import { useLanguage, useSetLanguage } from 'context/languageContext';
import React, { Suspense, useEffect } from 'react';
import { Navigate, useLocation, useRoutes } from 'react-router-dom';
import { RUTAS_GENERALES_MUL2 } from 'utils/constants';

const Avisos = React.lazy(() => import('components/features/setting/avisos/Avisos'));
const ExploreFullScreen = React.lazy(() => import('screens/exploreScreen/ExploreFullScreen'));
const FavoritesScreen = React.lazy(() => import('screens/favoritesScreen/FavoritesScreen'));
const HomeScreen = React.lazy(() => import('screens/homeScreen/HomeScreen'));
const EmtNews = React.lazy(() => import('screens/emtNews/EmtNews'));
const LinesScreen = React.lazy(() => import('screens/linesScreen/LinesScreen'));
const MapContainerScreen = React.lazy(() => import('screens/mapContainerScreen/MapContainerScreen'));
const Wrapper = React.lazy(() => import('components/templates/wrapper/Wrapper'));
const FullScreenWrapper = React.lazy(() => import('components/templates/fullscreenwrapper/FullScreenWrapper'));
const FlatScreenWrapper = React.lazy(() => import('components/templates/flatScreenwrapper/FlatScreenWrapper'));
const EmtNewDetail = React.lazy(() => import('screens/emtNewDetail/EmtNewDetail'));
const EventDetail = React.lazy(() => import('screens/newsScreen/components/eventDetail/EventDetail'));
/* const ActivateAccount = React.lazy(() => import('screens/activateAccount/ActivateAccount'));
const RecoveryPassword = React.lazy(() => import('screens/recoveryPassword/RecoveryPassword')); */
const ErrorScreen = React.lazy(() => import('screens/errorScreen/ErrorScreen'));
const PlannerScreen = React.lazy(() => import('screens/plannerScreen/PlannerScreen'));
const SettingScreen = React.lazy(() => import('screens/settingScreen/SettingScreen'));
const SettingScreenDetail = React.lazy(() => import('screens/settingScreen/settingScreenDetail/SettingScreenDetail'));
const Faq = React.lazy(() => import('screens/atClient/faq/Faq'));
const FaqCategories = React.lazy(() => import('screens/atClient/faq/faqAccessibility/FaqCategories'));
const Contact = React.lazy(() => import('screens/atClient/contact/Contact'));
const PointsSale = React.lazy(() => import('screens/rates/pointsSales/PointsSale'));
const StaticScreen = React.lazy(() => import('screens/staticScreen/StaticScreen'));
const Rates = React.lazy(() => import('screens/rates/rates/Rates'));
const RedirectFormOldWeb = React.lazy(() => import('screens/linesScreen/RedirectFormOldWeb'));
const PrivacyPolicyScreen = React.lazy(() => import('screens/PrivacyPolicyScreen/PrivacyPolicyScreen'));
const LegalNotice = React.lazy(() => import('screens/LegalNotice/LegalNotice'));
const OverlappingScreen = React.lazy(() => import('screens/OverlappingScreen/OverlappingScreen'));
const AvisosDetailScreen = React.lazy(() => import('components/features/setting/avisos/avisosDetail/AvisosDetailScreen'));
const StopQr = React.lazy(() => import('screens/stopQr/StopQr'));
const ComplaintsAndSuggestions = React.lazy(() => import('screens/ComplaintsAndSuggestions/ComplaintsAndSuggestions'));
const ComplaintsFormScreen = React.lazy(() => import('screens/ComplaintsAndSuggestions/components/complaintsFormScreen/ComplaintsFormScreen'));
const InquiriesFormScreen = React.lazy(() => import('screens/ComplaintsAndSuggestions/components/inquiriesFormScreen/InquiriesFormScreen'));
const CookiesPolicyScreen = React.lazy(() => import('screens/CookiesPolicyScreen/CookiesPolicyScreen'));
const IndependentStaticScreen = React.lazy(() => import('screens/staticScreen/IndependentStaticScreen'));

// import EmtNewDetailSkeleton from 'screens/emtNewDetail/EmtNewDetailSkeleton';

function Router({ precargaLoaded }) {
  const currentLanguage = useLanguage();
  const location = useLocation();
  const setLanguage = useSetLanguage();

  useEffect(() => {
    const keys = Object.keys(RUTAS_GENERALES_MUL2.home);
    const languageURL = location.pathname.split('/')[1];

    if (keys.includes(languageURL)) {
      setLanguage(languageURL);
    }
  }, [location.pathname]);

  let element = useRoutes([
    {
      path: '/' + currentLanguage + '/',
      element: <Wrapper precarga={precargaLoaded} />,
      children: [
        {
          path: RUTAS_GENERALES_MUL2.notices[currentLanguage],
          element: <Avisos />,
        },
        {
          path: `${RUTAS_GENERALES_MUL2.notices[currentLanguage]}:id`,
          element: <AvisosDetailScreen />,
        },
        {
          path: RUTAS_GENERALES_MUL2.settings[currentLanguage],
          element: <SettingScreen />,
        },
        {
          path: RUTAS_GENERALES_MUL2.settings_conf[currentLanguage],
          element: <SettingScreenDetail />,
        },
        { path: RUTAS_GENERALES_MUL2.atclientFaq[currentLanguage], element: <Faq /> },
        { path: RUTAS_GENERALES_MUL2.atclientComplaintsSuggestions[currentLanguage], element: <ComplaintsAndSuggestions /> },
        { path: RUTAS_GENERALES_MUL2.atclientComplaints[currentLanguage], element: <ComplaintsFormScreen /> },
        { path: RUTAS_GENERALES_MUL2.atclientInquiry[currentLanguage], element: <InquiriesFormScreen /> },
        {
          path: RUTAS_GENERALES_MUL2.atclientFaqCategory[currentLanguage],
          element: <FaqCategories />,
        },
        { path: RUTAS_GENERALES_MUL2.ratesDetail[currentLanguage], element: <Rates /> },
        {
          path: RUTAS_GENERALES_MUL2.emtNewDetail[currentLanguage] + ':newId/:title/',
          element:

              <EmtNewDetail />

          ,
        },
        // { path: RUTAS_GENERALES_MUL2.emt[currentLanguage], element: <EmtNewDetailSkeleton /> },
        { path: RUTAS_GENERALES_MUL2.rates[currentLanguage] + ':pageId', element: <StaticScreen /> },
        { path: RUTAS_GENERALES_MUL2.emt[currentLanguage] + ':pageId', element: <StaticScreen /> },
        {
          path: RUTAS_GENERALES_MUL2.atclient[currentLanguage] + '*',
          element: <StaticScreen />,
        },
        {
          path: RUTAS_GENERALES_MUL2.atclient[currentLanguage] + ':pageId' ,
          element: <StaticScreen />,
        },
      ],
    },
    {
      path: '/' + currentLanguage + '/',
      element: <FlatScreenWrapper precarga={precargaLoaded} />,
      children: [
        {
          path: RUTAS_GENERALES_MUL2.atclientContact[currentLanguage],
          element: <Contact precarga={precargaLoaded} />,
        },
        { path: RUTAS_GENERALES_MUL2.emtNews[currentLanguage], element: <EmtNews /> },
      ],
    },
    {
      path: '/' + currentLanguage + '/',
      element: <FullScreenWrapper precarga={precargaLoaded} />,
      children: [
        {
          path: '',
          element: <MapContainerScreen precarga={precargaLoaded} />,
          children: [
            {
              path: RUTAS_GENERALES_MUL2.planner[currentLanguage] + '/*',
              element: <PlannerScreen />,
            },
            {
              path: RUTAS_GENERALES_MUL2.paradas[currentLanguage] + '/*',
              element: <ExploreFullScreen precarga={precargaLoaded} />,
            },
            {
              path: RUTAS_GENERALES_MUL2.settingsFavorites[currentLanguage],
              element: <FavoritesScreen />,
            },
            {
              path: 'overlapping/',
              element: <OverlappingScreen />,
            },
            { path: RUTAS_GENERALES_MUL2.lines[currentLanguage], element: <LinesScreen /> },
            {
              path: ':param1/-/:param2/:num/*',
              element: <RedirectFormOldWeb />,
            },

            {
              path:
                RUTAS_GENERALES_MUL2.lines[currentLanguage] +
                ':code/:name/:tripId/:headSign/:directionId/:subLineId',
              element: <LinesScreen />,
            },
            {
              path: RUTAS_GENERALES_MUL2.lines[currentLanguage] + ':code',
              element: <LinesScreen />,
            },

            {
              path: RUTAS_GENERALES_MUL2.ratesPointsSale[currentLanguage],
              element: <PointsSale />,
            },
            { path: RUTAS_GENERALES_MUL2.eventDetail[currentLanguage], element: <EventDetail precarga={precargaLoaded}/> },
          ],
        },
      ],
    },
    {
      path:'p/:qr',
      element: <StopQr precarga={precargaLoaded} />,
    },
    { path: RUTAS_GENERALES_MUL2.error, element: <ErrorScreen errorCode={500} /> },
    {
      path: '/' + currentLanguage + '/',
      children: [{ path: RUTAS_GENERALES_MUL2.home[currentLanguage], element: <HomeScreen /> }],
    },
    {
      path: RUTAS_GENERALES_MUL2.main,
      element: <Navigate to={currentLanguage + '/' + RUTAS_GENERALES_MUL2.home[currentLanguage]} />,
    },
    {
      path: '/' + currentLanguage + '/' + RUTAS_GENERALES_MUL2.privacyPolicy[currentLanguage],
      element: <PrivacyPolicyScreen />,
    },
    {
      path: '/' + currentLanguage + '/' + RUTAS_GENERALES_MUL2.legalNotice[currentLanguage],
      element: <LegalNotice />,
    },
    {
      path: '/' + currentLanguage + '/' + RUTAS_GENERALES_MUL2.cookiesPolicy[currentLanguage],
      element: <CookiesPolicyScreen />,
    },
    {
      path: '/' + currentLanguage + '/' + RUTAS_GENERALES_MUL2.static + '/*',
      element: <StaticScreen />,
    },
    {
      path: '/' + currentLanguage + '/' + RUTAS_GENERALES_MUL2.rates[currentLanguage] + '/*',
      element: <StaticScreen />,
    },
    {
      path: '/' + currentLanguage + '/' + RUTAS_GENERALES_MUL2.static2,
      element: <StaticScreen />,
    },
    {
      path: '/' + currentLanguage + '/*',
      element: <IndependentStaticScreen />,
    },
    {
      path: RUTAS_GENERALES_MUL2.any,
      element: <ErrorScreen errorCode={404} />,
    },
    /* {
      path: RUTAS_GENERALES_MUL2.activateAccount,
      element: <ActivateAccount />,
    },
    {
      path: RUTAS_GENERALES_MUL2.recoveryPassword,
      element: <RecoveryPassword />,
    }, */
  ]);

  return <Suspense fallback={null}>{element}</Suspense>;
}

export default React.memo(Router);
